import React, { Component } from "react";
import { Field } from "formik";
import ColorField from "../fields/ColorField";
import { Fieldset, Picker } from "../../theme/styled";
import FieldBasketballOne from "./FieldBasketballOne";
import FieldBasketballTwo from "./FieldBasketballTwo";
import FieldBasketballGoals from "./FieldBasketballGoals";
import ConditionalComponent from "../ConditionalComponent";
import { FIELD_TYPES } from "../../constants";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

class FieldsBasketball extends Component {
  render() {
    const { field } = this.props;
    const { basketballTwo, basketballOne } = field.options;
    return (
      <Fieldset>
        <h2>
          <FormattedMessage id="basketball.title" defaultMessage="Koszykówka" />
        </h2>
        <ConditionalComponent component={FieldBasketballOne} />
        <ConditionalComponent
          component={FieldBasketballTwo}
          conditions={{
            minX: 20,
            fieldType: FIELD_TYPES.basketball,
          }}
        />
        <ConditionalComponent
          component={FieldBasketballTwo}
          conditions={{
            minX: 20,
            fieldType: FIELD_TYPES.volleyball,
          }}
        />
        <ConditionalComponent
          component={FieldBasketballTwo}
          conditions={{
            minX: 20,
            fieldType: FIELD_TYPES.tennis,
          }}
        />
        <ConditionalComponent
          component={FieldBasketballGoals}
          conditions={{
            minX: 20,
            fieldType: FIELD_TYPES.multisport,
          }}
        />
        {basketballTwo || basketballOne ? (
          <Picker>
            <Field
              name="basketballColor"
              component={ColorField}
              label="Kolory trumien"
            />
          </Picker>
        ) : null}
      </Fieldset>
    );
  }
}

const mapState = ({ field }) => ({ field });
FieldsBasketball = connect(mapState)(FieldsBasketball);
export default injectIntl(FieldsBasketball);
